module.exports = __webpack_public_path__ + "static/img/far1.e91ec41b.png";